import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  selectAllComplianceNotifications,
  selectAllTrainingNotifications,
  selectMostImportantComplianceNotification,
  selectMostImportantTrainingNotification,
} from '../+state/notification.selectors';
import {
  AvailableComplianceNotifications,
  AvailableTrainingNotifications,
  ComplianceNotificationTypes,
  TrainingNotificationTypes,
} from '../+state/notification.models';
import { NotificationActions } from '../+state/notification.actions';

@Injectable({
  providedIn: 'root',
})
export class NotificationStateService {
  constructor(private _store: Store) {}

  public getAllComplianceNotifications(): Observable<ComplianceNotificationTypes> {
    return this._store.select(selectAllComplianceNotifications);
  }

  public getTopPriorityComplianceNotification(): Observable<AvailableComplianceNotifications | null> {
    return this._store.select(selectMostImportantComplianceNotification);
  }

  public getAllTrainingNotifications(): Observable<TrainingNotificationTypes> {
    return this._store.select(selectAllTrainingNotifications);
  }

  public getTopPriorityTrainingNotification(): Observable<AvailableTrainingNotifications | null> {
    return this._store.select(selectMostImportantTrainingNotification);
  }

  public addComplianceNotification(
    notificationType: AvailableComplianceNotifications,
  ): void {
    this._store.dispatch(
      NotificationActions.activateComplianceNotification({ notificationType }),
    );
  }

  public removeComplianceNotification(
    notificationType: AvailableComplianceNotifications,
  ): void {
    this._store.dispatch(
      NotificationActions.removeComplianceNotification({ notificationType }),
    );
  }

  public addTrainingNotification(
    notificationType: AvailableTrainingNotifications,
  ): void {
    this._store.dispatch(
      NotificationActions.activateTrainingNotification({ notificationType }),
    );
  }

  public removeTrainingNotification(
    notificationType: AvailableTrainingNotifications,
  ): void {
    this._store.dispatch(
      NotificationActions.removeTrainingNotification({ notificationType }),
    );
  }

  public clearAllNotification(): void {
    this._store.dispatch(NotificationActions.clearNotifications());
  }
}
